/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Http from './AxiosClient';
import type { AxiosError, AxiosRequestConfig } from 'axios';
import type HttpClient from './HttpClient';

export default function useHttp(): HttpClient<AxiosRequestConfig, AxiosError> {
    return new Http();
}
